<template>
    <div>
        <GridReceptor />
    </div>
</template>
<script>
import GridReceptor from "./GridReceptor.vue";

export default {
    data: () => ({

    }),

    components: {
        GridReceptor
    }
}
</script>